/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHotspotContentFragment} from '@amblique/contentful/app/contentful/fragments/hotspot-content/base-hotspot-content.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullHotspotContentFragment = gql`
  ${BaseHotspotContentFragment}
  ${ImageFragment}
  ${VideoFragment}

  fragment FullHotspotContentFragment on HotspotContent {
    ...BaseHotspotContentFragment

    image {
      ...ImageFragment
    }
    mobileImage {
      ...ImageFragment
    }
    mobileVideo {
      ...VideoFragment
    }
    video {
      ...VideoFragment
    }
  }
`;
